"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractIdentifierProvider = void 0;
/**
 * An abstract class for the {@link @veramo/did-manager#DIDManager} identifier providers
 * @public
 */
class AbstractIdentifierProvider {
}
exports.AbstractIdentifierProvider = AbstractIdentifierProvider;
//# sourceMappingURL=abstract-identifier-provider.js.map